// App-wide constants.

// Backend API base URL (no trailing slash — request paths already start with "/").
// Production (live server):
export const BASE_URL = "https://trustmark.mytrustlab.co.in/api";
// Local development:
// export const BASE_URL = "http://localhost:5000/api";
